import React from "react";

import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";

// Styles
import { useStyles } from "./FilterModalSection.styles";

const FilterModalSection = ({ title, noDivider, children }) => {
  const classes = useStyles();

  return (
    <>
      <Typography gutterBottom className={classes.sectionHeader} variant="h3">
        {title}
      </Typography>
      <Grid container className={classes.modalSection}>
        {children}
      </Grid>
      {!noDivider && <Divider />}
    </>
  );
};

export default FilterModalSection;
